import React, { useEffect, useState } from "react";
import Box from "../components/Box";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import logos from "../assets/logos.jpeg";
import profileEmpty from "../assets/profile-empty.webp";
import { useStore } from "../store";
import packageJson from "../../package.json";
import LoadingFullComponent from "../components/LoadingFullComponent";
import PopUpConfirmLogout from "../components/popup/PopUpConfirmLogout";
import axios from "axios";
import toast from "react-hot-toast";
import { Buffer } from "buffer";
import { PAYMENT_GATEWAY_URL,PAYMENT_SECRET_KEY } from "../constants";
import convertNumber from "../helpers/convertNumber";

export default function MainLayout() {
  const [sidebarToggle, setSidebarToggle] = useState(true);
  const [popup, setPopup] = useState();
  const [paymentCredit,setPaymentCredit] = useState(0);
  console.log("paymentCredit",paymentCredit)

  const {  profile, isLoadingDetailPage, manualLogout } = useStore();

  useEffect(() =>{
   if(PAYMENT_GATEWAY_URL && PAYMENT_SECRET_KEY){
    getCredit();
   }
  },[PAYMENT_SECRET_KEY,PAYMENT_GATEWAY_URL])

  const handleLogout = async () => {
    manualLogout();
  };





  const getCredit = async () => {
    try {
    const res = await axios.get(`${PAYMENT_GATEWAY_URL}/v1/api/report/get-payment-credit`, {
      headers: {
        'Content-Type': 'application/json', 
         'secretKey': PAYMENT_SECRET_KEY
      }
    });
    if(res.status === 200){
      console.log("res::::",res?.data)
      setPaymentCredit(res?.data?.total)
    }
    }catch (error) {
      console.log("Error: ", error)
    }
  }
  const handleRequestToken = async () => {
    const authHeader = `Basic ${Buffer.from(`${PAYMENT_SECRET_KEY}`).toString("base64")}`;
  
      try{
       const response = await axios.post(`${PAYMENT_GATEWAY_URL}/v1/api/auth/request-login-token`,
         {}, // Body (empty object since you're not sending data in the body)
         {
           headers: {
             Authorization: authHeader, // Correctly placed headers here
           },
         }
       );
       if (response.status === 200) {
         console.log(response.data);
         const token = response.data?.accessToken || "";
         window.open(`https://portal.lailaolab.la/?lang=la&code=${token}`, "_blank");
       }
      }catch(error){
       console.error(error);
       toast.error("Invalid Key")
      }
     };


















  const Sidebar = ({ toggle, role }) => {
    const navigate = useNavigate();
    const [list, setList] = useState([
      {
        icon: "uil:chart-pie-alt",
        title: "ລາຍງານ",
        path: "/dashboard",
        key: "dashboard",
        show: true,
      },
      {
        icon: "uil:money-stack",
        title: "ປ່ອຍກູ້ ແລະ ເກັບເງິນ",
        path: "/loan",
        key: "loan",
        show: true,
      },
      {
        icon: "uil:users-alt",
        title: "ບັນຊີສະມາຊິກ",
        path: "/membership",
        key: "member",
        show: true,
      },
      {
        icon: "uil:user-plus",
        title: "ຈັດການພະນັກງານ",
        path: "/staff",
        key: "staff",
        show: false,
      },
    ]);
    const { pathname } = useLocation();

    useEffect(() => {
      console.log("role", role);
      if (role === "STAFF") {
        setList([
          {
            icon: "uil:chart-pie-alt",
            title: "ລາຍງານ",
            path: "/dashboard",
            key: "dashboard",
            show: true,
          },
          {
            icon: "uil:money-stack",
            title: "ປ່ອຍກູ້ ແລະ ເກັບເງິນ",
            path: "/loan",
            key: "loan",
            show: true,
          },
          {
            icon: "uil:users-alt",
            title: "ຈັດການບັນຊີລູກໜີ້",
            path: "/membership",
            key: "member",
            show: true,
          },
          {
            icon: "uil:user-plus",
            title: "ຈັດການບັນຊີພະນັກງານ",
            path: "/staff",
            key: "staff",
            show: false,
          },
        ]);
      } else if (role === "MANAGER") {
        setList([
          {
            icon: "uil:chart-pie-alt",
            title: "ລາຍງານ",
            path: "/dashboard",
            key: "dashboard",
            show: true,
          },
          {
            icon: "uil:money-stack",
            title: "ປ່ອຍກູ້ ແລະ ເກັບເງິນ",
            path: "/loan",
            key: "loan",
            show: true,
          },
          {
            icon: "uil:users-alt",
            title: "ຈັດການບັນຊີລູກໜີ້",
            path: "/membership",
            key: "member",
            show: true,
          },
          {
            icon: "uil:user-plus",
            title: "ຈັດການບັນຊີພະນັກງານ",
            path: "/staff",
            key: "staff",
            show: true,
          },
        ]);
      }
    }, [role]);

    useEffect(() => {
      const pathNow = pathname.split("/")?.[1];
      setList((prev) => {
        return prev?.map((data) => {
          if (data.path === `/${pathNow}`) {
            return { ...data, active: true };
          } else {
            return { ...data, active: false };
          }
        });
      });
    }, [pathname]);

    return (
      <div
        className="bg-primary"
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          // color: "white",
          gap: 10,
          padding: 10,
        }}
      >
        {list
          ?.filter((e) => e?.show)
          ?.map((e, i) => (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                gap: toggle ? 10 : 0,
                textAlign: "center",
                fontSize: 16,
                padding: 4,
                backgroundColor: e?.active ? "#FFFFFF" : "#0178c1",
                borderRadius: 8,
                color: e?.active ? "#0178c1" : "#FFFFFF",
                fontWeight: e?.active ? "700" : "normal",
                cursor: "pointer",
              }}
              onClick={() => {
                if (e?.path) {
                  navigate(e?.path);
                }
              }}
              key={i}
            >
              <div className="icon-title">
                <div>
                  <Icon
                    icon={e?.icon}
                    style={{ width: 30, height: 30, padding: 4 }}
                  />
                </div>
                <div> {toggle && <div>{e?.title}</div>}</div>
              </div>
            </div>
          ))}
      </div>
    );
  };

  const TopItemSidebar = ({ toggle, onToggle }) => {
    return (
      <div
        style={{
          width: "100%",
          color: "white",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 10,
          position: "relative",
        }}
      >
        <div className="icon-title">
          <div style={{ marginBottom: 10,  }}>
            <img src={logos} alt="" className="microfinance-logo " style={{ width: sidebarToggle ? 60 : 40, height: sidebarToggle ? 60 : 40}} />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Box
      style={{
        paddingLeft: { md: 65 },
        width: "100%",
        height: "100dvh",
        display: "grid",
        gridTemplateColumns: `${sidebarToggle ? "230px" : "90px"} 1fr`,
        backgroundColor: "#fafafafa",
      }}
    >
      {/* sidebar */}
      <div
        className="bg-primary"
        style={{
          display: "flex",
          position: "flex",
          flexDirection: "column",
          gap: 1,
          width:`${sidebarToggle ? "230px" : "90px"} 1fr`
        }}
      >
        <TopItemSidebar
          toggle={sidebarToggle}
          onToggle={() => setSidebarToggle((prev) => !prev)}
        />
        <Sidebar toggle={sidebarToggle} role={profile?.role} />
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center",
            paddingBottom: 10,
            color: "#fff",
            fontSize: sidebarToggle ? 14 : 10,
            textAlign: "center",
          }}
        >
          Version: {packageJson?.version}
        </div>
      </div>

      {/* content */}
      <div
        style={{
          width: "100%",
          zIndex: 0,
          overflowY: "auto", // Enable vertical scrolling
        }}
      >
        <div
          style={{
            top: 0,
            right: 0,
            width: sidebarToggle ? "calc(100% - 230px)" : "calc(100% - 90px)",
            zIndex: 1000,
            boxShadow: "3px 0px 5px rgba(0,0,0,0.05)",
            backgroundColor: "white",
            height: 60,
            display: "flex",
            justifyContent: "flex-between",
            alignItems: "center",
            paddingRight: 10,
            position: "fixed",

          }}
        >
          <div
            style={{
               width:"100%",
              alignContent: "center",
              display:"flex",
              marginLeft: "10px",
            }}
          >
             <button onClick={handleRequestToken}
              style={{background:"rgb(77,181,255)",color:"white",padding:"5px 10px",borderRadius:"5px",cursor:"pointer",border:"none"}}
             >ຍອດເງີນໃນ Phapay:{convertNumber(paymentCredit)} ກີບ</button>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 10,
              color: "#6C757D",
              border: "1px solid #ccc",
              padding: 5,
              borderRadius: 8,
              cursor: "pointer",
            }}
            onClick={() => setPopup({ PopUpConfirmLogout: true })}
          >
            <div
              style={{
                background: "#ccc",
                width: 28,
                height: 28,
                borderRadius: "50%",
              }}
            >
              <img
                src={profileEmpty}
                alt="profile"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
            <div style={{ fontSize: 16 }}>{profile?.fullName}</div>
            <Icon
              icon="mi:log-out"
              style={{ width: 20, height: 20, color: "#0178c1" }}
            />
          </div>
        </div>
        <div style={{ padding: 16, marginTop: 48, minHeight: "100vh" }}>
          <LoadingFullComponent show={isLoadingDetailPage} />
          <Outlet />
        </div>
      </div>
      <PopUpConfirmLogout
        onClose={() => setPopup()}
        open={popup?.PopUpConfirmLogout}
        onSubmit={() => handleLogout()}
      />
    </Box>
  );
}
